import { IFeatureLoyaltyClaimPointsContentQuery } from 'generated/sanity-graphql';

export enum ClaimMethod {
  QR_SCAN,
  MANUAL,
}

export type ClaimPointsUIData = IFeatureLoyaltyClaimPointsContentQuery['ClaimPointsUI'];
